<script>
  import {
    page
  } from '@inertiajs/svelte'

  import Main from "../layouts/_main.svelte"

  let { body } = $props()
</script>

<Main {...$page.props}>
  {@html body}
</Main>
